export const ORDER_CUTOFF_INSTRUCTIONS_FALLBACK =
  'No order instructions set by supplier. Contact the supplier in Messenger if you have questions.'

export const ORDER_CUTOFF_TIME_LABEL = 'Cut-off time'

export const ORDER_CUTOFF_INSTRUCTIONS_LABEL = 'Order cut off instructions'

export const ORDER_CUTOFF_TIME_HELPER_TEXT =
  'Orders placed after this time will roll to the next available delivery day.'

export const ORDER_CUTOFF_INSTRUCTIONS_HELPER_TEXT =
  'Shown to venues in Your Suppliers. Use plain-language ordering instructions, e.g. "Order before 4pm for next day delivery".'

export const resolveOrderCutOffInstructionsDisplay = instructions => {
  const normalized = String(instructions ?? '').trim()

  return normalized || ORDER_CUTOFF_INSTRUCTIONS_FALLBACK
}

/**
 * Format supplier cut-off time and venue instructions for tables/cards.
 * @param {{ supplierCutOffTime?: string|null, venueOrderCutOffTime?: string|null }} params
 */
export const formatVenueSupplierOrderCutOff = ({
  supplierCutOffTime,
  venueOrderCutOffTime,
}) => {
  const time = String(supplierCutOffTime ?? '').trim()
  const instructions =
    resolveOrderCutOffInstructionsDisplay(venueOrderCutOffTime)
  const parts = []

  if (time) {
    parts.push(time)
  }

  parts.push(instructions)

  return parts.join(' · ')
}
